import React from "react";

const ShapeMobile5 = () => {
	return (
		<svg
			width={253}
			height={463}
			viewBox="0 0 253 463"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_f_34_269)">
				<path
					d="M-11.4537 306.018C29.7017 324.218 77.8183 305.609 96.0182 264.454C114.218 223.298 95.6095 175.182 54.4536 156.982C13.2986 138.782 -34.8183 157.391 -53.0182 198.546C-71.2182 239.702 -52.609 287.818 -11.4537 306.018Z"
					fill="url(#paint0_radial_34_269)"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_34_269"
					x={-210}
					y={0}
					width={463}
					height={463}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={75}
						result="effect1_foregroundBlur_34_269"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_34_269"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(179.597 331.245) rotate(-154.439) scale(376.554 341.937)"
				>
					<stop offset="0.34394" stopColor="#00EBFF" />
					<stop offset="0.619147" stopColor="#FF39B0" />
					<stop offset="0.974236" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default ShapeMobile5;
